import SubscriptionResource from "./subscription.resource";

const subscriptionModule = angular
  .module("app.resources.subscription", [])
  .service("Subscription", SubscriptionResource);

export default subscriptionModule;



// WEBPACK FOOTER //
// ./src/resources/subscription/subscription.module.js